import { Controller } from "@hotwired/stimulus"

// data-controller="dropdown"
// data-action="click->dropdown#toggle click@window->dropdown#hideOnClickOutside keydown@window->dropdown#hideOnEscape"
// <div data-dropdown-target="menu" hidden>...</div>
//
// Positions the menu with `position: fixed` (set on toggle, via JS) so it
// escapes the mobile sidebar's `overflow: hidden` clipping.
export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    const willOpen = this.menuTarget.hidden
    if (willOpen) this.position()
    this.menuTarget.hidden = !willOpen
    this.element.setAttribute("aria-expanded", String(willOpen))
  }

  hide() {
    this.menuTarget.hidden = true
    this.element.setAttribute("aria-expanded", "false")
  }

  hideOnClickOutside(event) {
    if (!this.element.contains(event.target)) this.hide()
  }

  hideOnEscape(event) {
    if (event.key === "Escape") this.hide()
  }

  position() {
    const rect = this.element.getBoundingClientRect()
    this.menuTarget.style.top = `${rect.bottom + 6}px`
    this.menuTarget.style.right = `${window.innerWidth - rect.right}px`
  }
}
